import {
  GET_OVERVIEW,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_PROPOSALS_BY_PLANS,
  GET_DEMOGRAPHIC_DATA,
  GET_OVERVIEW_MAPS_DATA,
  GET_OVERVIEW_SALES_FORECAST,
  GET_PROPOSALS_SITUATION,
} from './actionType';

// common success
export const OverviewApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const OverviewApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetOverview = (office) => ({
  type: GET_OVERVIEW,
  payload: { office },
});

export const GetOverviewProposalsByPlans = (office) => ({
  type: GET_PROPOSALS_BY_PLANS,
  payload: { office },
});

export const GetDemographicData = (office) => ({
  type: GET_DEMOGRAPHIC_DATA,
  payload: { office },
});

export const GetOverviewMapsData = (office) => ({
  type: GET_OVERVIEW_MAPS_DATA,
  payload: { office },
});

export const GetOverviewSalesForecast = (office) => ({
  type: GET_OVERVIEW_SALES_FORECAST,
  payload: { office },
});

export const GetProposalsSituation = (office, situation, params) => ({
  type: GET_PROPOSALS_SITUATION,
  payload: { office, situation, params },
});
